export const token_addresses = {
  emojiFlagAddress:"0xafe4126da89c03c4fB63A82A863083A7b675a936"
}
